export function setActiveTab(state, activeTab) {
    state.activeTab = activeTab;
}

export function setSelectedPlan(state, selectedPlan) {
    state.selectedPlan = selectedPlan;
}

export function setProducts(state, products) {
    state.products = products;
}

export function setProFeatures(state, proFeatures) {
    state.proFeatures= proFeatures;
}

export function setFeatureGroups(state, featureGroups) {
    state.featureGroups = featureGroups;
}

export function setTestimonials(state, testimonials) {
    state.testimonials = testimonials;
}

export function setFaqs(state, faqs) {
    state.faqs = faqs;
}

export function setPlans(state, plans) {
    state.plans = plans;
}

export function setGender(state, gender) {
    state.gender = gender;
}

export function setSport(state, sport) {
    state.sport = sport;
}

export function setPricingEssentialsMounted(state, value) {
    state.pricingEssentialsMounted = value;
}

export function setRosterNeedsEnabled(state, value) {
    state.rosterNeedsEnabled = value;
}
